import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";
const { banConfSwitch, chargeRuleSave, chargeRuleDel, getOssSign } =
  httpApi.chargeRule;

export interface BanConfSwitchProps {
  id?: number;
  key?: string;
  name?: string;
  value?: string;
}

// 规则配置列表
export const apiBanConfSwitch = (): any =>
  http.httpPost({
    url: banConfSwitch,
  });

// 规则配置列表编辑
interface ChargeRuleSaveParams {
  rule: string;
}
export const apiChargeRuleSave = (json: ChargeRuleSaveParams): any =>
  http.httpPost({
    url: chargeRuleSave,
    json,
  });

// 删除规则
interface ChargeRuleDelParams {
  id?: number;
}
export const apiChargeRuleDel = (json: ChargeRuleDelParams): any =>
  http.httpPost({
    url: chargeRuleDel,
    json,
  });

// 删除规则
interface GetOssSignParams {
  dirName: string;
}
export const apiGetOssSign = (json: GetOssSignParams): any =>
  http.httpPost({
    url: getOssSign,
    json,
  });
